import script from "./OrderAddress.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderAddress.vue?vue&type=script&setup=true&lang=js"

import "./OrderAddress.vue?vue&type=style&index=0&id=c070aba2&lang=scss&scoped=true"

import exportComponent from "D:\\工作项目\\美国站\\h5\\us-station-number\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c070aba2"]])

export default __exports__